import cloneDeep from 'lodash.clonedeep';

const flattenData = data => {
  const copy = cloneDeep(data);
  const result = [];
  const flattenFunc = level => {
    for (const item of level) {
      result.push(item);
      if (item.items) {
        flattenFunc(item.items);
      }
    }
  };
  flattenFunc(copy);
  return result;
};

export { flattenData };
